import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const accessingIntegrationEditor = {
  element: '#plugins > div.page-content > div.plugin-cards > div.plugin-card',
  popover: {
    title: 'Accessing the Integration Editor',
    description:
      "Each integration card includes an actions menu, accessible via the <code><i class='os-icon-more-horizontal'></i></code> button in the upper-right corner.",
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const actionsToggle = document.querySelector('#plugins > div.page-content > div > div:nth-child(1) > div.action');

      if (actionsToggle) {
        actionsToggle.classList.remove('tour-show');

        GLOBAL_DRIVER_OBJECT.movePrevious();
      }
    },
    onNextClick: () => {
      const actionsMenu = document.querySelector(
        '#plugins > div.page-content > div > div:nth-child(1) > div.action.tour-show > div > div'
      );
      const actionsToggle = document.querySelector('#plugins > div.page-content > div > div:nth-child(1) > div.action');

      if (actionsMenu && actionsToggle) {
        actionsMenu.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};

export const editActionsMenu = {
  element: '#plugins > div.page-content > div > div:nth-child(1) > div.action.tour-show > div > ul > li:nth-child(1)',
  popover: {
    title: 'Actions Menu Options',
    description:
      'Use the <strong>&quot;Edit&quot;</strong> action to access the integration edit page, or simply click directly on the card to make changes.',
    side: 'right',
    align: 'center',
    onNextClick: () => {
      const actionsToggle = document.querySelector('#plugins > div.page-content > div > div:nth-child(1) > div.action');
      const editBtn = document.querySelector(
        '#plugins > div.page-content > div > div:nth-child(1) > div.action.tour-show > div > ul > li:nth-child(1) > button'
      );

      if (actionsToggle) {
        editBtn.click();

        actionsToggle.classList.remove('tour-show');

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};
